import { useEffect, useState } from 'react';

export const useTrigger = ({ callback }) => {
  const [flag, setFlag] = useState<boolean>(false);

  useEffect(() => {
    if (flag) {
      setFlag(false);
      callback();
    }
  }, [flag]);

  const trigger = () => {
    setFlag(true);
  };

  return { trigger };
};
